// @ts-expect-error static asset
import appMarketplaceImageUrl from 'bender-url!../../img/app-marketplace-network-1x.png';
// @ts-expect-error static asset
import appMarketplaceImageUrl2x from 'bender-url!../../img/app-marketplace-network-2x.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { Button } from 'foundations-components/transitional/components/Button';
import { getAppMarketplaceUrl } from '../utils/urls';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AppMarketplaceSection({
  onTrackInteraction
}) {
  return /*#__PURE__*/_jsx(MediaSection, {
    button: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "app-marketplace-button",
      href: getAppMarketplaceUrl(),
      onClick: () => onTrackInteraction('click app marketplace section button'),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceUnified.sections.appMarketplace.buttonText"
      })
    }),
    color: "fill-surface-raised",
    "data-test-id": "app-marketplace-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.appMarketplace.description"
    }),
    media: /*#__PURE__*/_jsx(Image, {
      src: appMarketplaceImageUrl,
      srcSet: `${appMarketplaceImageUrl2x} 2x`,
      inlineSize: "100%",
      maxInlineSize: "500px",
      marginBlockEnd: "-1200"
    }),
    orientation: "media-right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.appMarketplace.title"
    })
  });
}